import * as React from "react";
import {
  Button,
  CssBaseline,
  TextField,
  Paper,
  Box,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import RefreshIcon from "@mui/icons-material/Refresh";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { LoginAction } from "../../redux/actions/authActons";

// Clean, professional theme
const theme = createTheme({
  palette: {
    primary: { main: "#1976d2" }, // Standard professional blue
    background: { default: "#f5f5f5" },
  },
});

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    document.title = "Login | Ledger";
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const mobile = data.get("mobile");

    if (mobile) {
      dispatch(LoginAction(mobile, navigate));
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {/* Container centers the login card on the screen */}
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Container component="main" maxWidth="xs">
          <CssBaseline />
          
          <Paper
            elevation={3}
            sx={{
              p: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: 2,
            }}
          >
            {/* Header Area */}
            <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", mb: 2 }}>
              <Typography component="h1" variant="h5" fontWeight="bold">
                Sign In
              </Typography>
              <IconButton size="small" onClick={() => window.location.reload()}>
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, alignSelf: "flex-start" }}>
              Please enter your WhatsApp number to continue.
            </Typography>

            {/* Form Area */}
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: "100%" }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="mobile"
                label="WhatsApp Number"
                name="mobile"
                autoFocus
                type="tel"
                variant="outlined"
                placeholder="Enter your number here"
                // Forces numeric keypad on mobile devices
                inputProps={{ 
                  inputMode: "numeric", 
                  pattern: "[0-9]*" 
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <WhatsAppIcon fontSize="small" color="action" />
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                size="large"
                sx={{ 
                  mt: 3, 
                  mb: 2, 
                  textTransform: "none", 
                  fontWeight: "bold",
                  height: "48px" 
                }}
              >
                Login 
              </Button>

              
            </Box>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}

// Simple Helper for Link (can be replaced with react-router-dom Link)
function Link({ children, href, sx }) {
  return (
    <Typography
      component="a"
      href={href}
      variant="body2"
      sx={{ cursor: "pointer", ...sx }}
    >
      {children}
    </Typography>
  );
}